import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetAllEnterpriseRemovedVideoInterface {
  id: string;
  search: string;
}

export const useGetAllEnterpriseRemovedVideos = () => {
  const mutate = useMutation(({ id, search }: GetAllEnterpriseRemovedVideoInterface) => {
    return get(`/external-api/get_all_removed_videos/${id}/${search}`);
  });

  return mutate;
};

export default useGetAllEnterpriseRemovedVideos;
